var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#264C86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 18.666L12.666 15.3327L13.5993 14.366L15.3327 16.0993V10.666H16.666V16.0993L18.3993 14.366L19.3327 15.3327L15.9993 18.666ZM11.9993 21.3327C11.6327 21.3327 11.3188 21.2021 11.0577 20.941C10.7966 20.6799 10.666 20.366 10.666 19.9993V17.9993H11.9993V19.9993H19.9993V17.9993H21.3327V19.9993C21.3327 20.366 21.2021 20.6799 20.941 20.941C20.6799 21.2021 20.366 21.3327 19.9993 21.3327H11.9993Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDownloadIcon);
export default __webpack_public_path__ + "static/media/new_download_icon.0a4eff531969c52cfd9c22d6ba07c3b9.svg";
export { ForwardRef as ReactComponent };